module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.pageHome.elements) ? _c('div', {
    staticClass: "landing-home"
  }, [_c('hero', {
    attrs: {
      "props": _vm.pageHome.elements,
      "heroHome": true
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "content-works",
    attrs: {
      "id": "section"
    }
  }, [_c('div', {
    staticClass: "inside"
  }, [(_vm.pageHome.elements.intro_paragraph) ? _c('p', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport",
      value: ({}),
      expression: "{}"
    }],
    staticClass: "intro_text"
  }, [_vm._v(_vm._s(_vm.pageHome.elements.intro_paragraph.value))]) : _vm._e(), _vm._v(" "), _c('boxes-wrapper', {
    attrs: {
      "boxes": _vm.works,
      "modularContent": _vm.modularContent,
      "boxlimit": 4,
      "showViewAll": false
    }
  })], 1)]), _vm._v(" "), _c('section', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "content-articles"
  }, [_c('div', {
    staticClass: "inside"
  }, [_c('h2', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "text-center"
  }, [_vm._v("Insights, commentary and news")]), _vm._v(" "), (_vm.pageHome.elements.related_words_description) ? _c('p', {
    staticClass: "text-center container"
  }, [_vm._v(_vm._s(_vm.pageHome.elements.related_words_description.value))]) : _vm._e(), _vm._v(" "), _c('articles-wrapper', {
    attrs: {
      "boxes": _vm.words,
      "isHome": true,
      "boxlimit": 4,
      "pathRoute": '/words',
      "showViewAll": true,
      "showCategory": true
    }
  })], 1)])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d0e437b","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/landings/Home.vue
// module id = 1541
// module chunks = 0